import { LucideIcon, Linkedin, Facebook, Instagram, Twitter } from 'lucide-react'

export interface SocialMedia {
    id: string
    name: string
    url: string
    icon: LucideIcon  // Ícone do Lucide
    enabled: boolean  // Liga/desliga a rede social
}

export const socialMedia: SocialMedia[] = [
    {
        id: 'linkedin',
        name: 'LinkedIn',
        url: 'https://www.linkedin.com/company/dpxp-it-solutions/',
        icon: Linkedin,
        enabled: true,
    },
    {
        id: 'facebook',
        name: 'Facebook',
        url: 'https://facebook.com/dpxpitsolutions',
        icon: Facebook,
        enabled: false,  // Desligado por enquanto
    },
    {
        id: 'instagram',
        name: 'Instagram',
        url: 'https://instagram.com/dpxpitsolutions',
        icon: Instagram,
        enabled: false,  // Desligado por enquanto
    },
    {
        id: 'twitter',
        name: 'Twitter / X',
        url: 'https://twitter.com/dpxpitsolutions',
        icon: Twitter,
        enabled: false,  // Desligado por enquanto
    },
]

